//Paquetes NPM de GYF. 
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, SagasHelper, RabbitListener, SagasProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';
import ContactoHelper from '../../../Common/Helpers/ContactoHelper';
import NovedadesManager from '../../../Common/Managers/NovedadesManager';
import BajaCuentaTarjetaManager from '../../../Common/Managers/BajaCuentaTarjetaManager';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

let _dispatch
//ACTION TYPES

export const GET_SCREEN_DATA_BAJA = 'GET_SCREEN_DATA_BAJA';
export const SELECT_VALOR_BAJA = 'SELECT_VALOR_BAJA';
export const SOLICITAR_BAJA_PREPAGA = 'SOLICITAR_BAJA_PREPAGA';
export const CANCELAR_CONFIRMADOR_BAJA = 'CANCELAR_CONFIRMADOR_BAJA';
export const MOSTRAR_SPINNER = 'MOSTRAR_SPINNER';
export const OCULTAR_SPINNER = 'OCULTAR_SPINNER';


export function dataInicial() {
    LogHelper.In(dataInicial.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let params = {
            'ADMINISTRADORA_ID': 3
        }

        Engine1Proxy.AddDataSourcesRequests(params, 'UP_GET_DATOS_BAJA_CUENTA_PREPAGA', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'motivosBaja');
        Engine1Proxy.Execute((data) => _callbackdataInicial(data), null, null, "CONSULTASOCIOS");
    }
}

function _callbackdataInicial(data) {
    let datos = {};
    datos.motivosBaja = JSON.parse(data.motivosBaja).Recordset0.Rows;

    _dispatch({ type: GET_SCREEN_DATA_BAJA, datos })
}

export function selectValorBaja(campo, valor) {
    LogHelper.In(selectValorBaja.name, campo, valor);
    return (dispatch, getState) => {
        let valida = true;

        switch (campo) {
            case "comentarioBaja": {
                valida = valor.length < 99;
                break;
            }
        }

        if (valida) {
            dispatch({ type: SELECT_VALOR_BAJA, valor, campo })
        }
    }
}

export function cancelar(){
    LogHelper.In(cancelar.name);
    return (dispatch, getState) => {        
        dispatch({ type: CANCELAR_CONFIRMADOR_BAJA, payload: false });
    }
}

export function solicitarBaja(data) {
    
    LogHelper.In(solicitarBaja.name);
    return (dispatch, getState) => {
          debugger
        _dispatch = dispatch;
        dispatch({ type: SOLICITAR_BAJA_PREPAGA, payload: true });
    }
}

export function DarBajaCuentaTarjeta(cuenta){
    LogHelper.In(DarBajaCuentaTarjeta.name);
    return (dispatch, getState) => {
        debugger
        const state = getState();     

        const { executionContext } = state.sesion;
        let cuentaTarjeta = {};
        cuentaTarjeta.Id = cuenta.Id;
        cuentaTarjeta.SucursalPedidoId = cuenta.sucursalSeleccionadaId;
        cuentaTarjeta.TipoBaja = 0;
        cuentaTarjeta.MotivoBajaId = cuenta.MotivoBaja;
        cuentaTarjeta.SolicitaCaidaCuotas = null;
        cuentaTarjeta.Comentarios = cuenta.ComentariosBaja;
        cuentaTarjeta.SaldoALaBaja = 0;
        cuentaTarjeta.UsuarioLogin = executionContext.login;
        cuentaTarjeta.Terminal = executionContext.terminalId;

        debugger
        dispatch({ type: MOSTRAR_SPINNER });

        BajaCuentaTarjetaManager.BajaCuentaTarjeta(cuentaTarjeta, SagasHelper.GetSagasId, viewCallback);

       // _dispatch = dispatch;
       // dispatch({ type: SOLICITAR_BAJA_PREPAGA, payload: true });
    }
}

function viewCallback(bajaId) {
    // _dispatch({
    //     type: NUMERO_BAJA_CUENTA,
    //     bajaId: bajaId
    // });
    _dispatch({
        type: OCULTAR_SPINNER
    });
}

